import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Classic from './Classic';
import LoadMore from './LoadMore';
import { LOAD_MORE } from '../../../../constants';

const ListPagination = ({
  listRef,
  listTotal,
  name,
  itemsPerPage,
  isInfinite,
  limitToUse,
  paginationType,
  currentPage,
  ...props
}) => {
  const [showPagination, setShowPagination] = useState(true);

  const isLoadMore = paginationType === LOAD_MORE;

  const scrollOnClick = () => {
    if (!isLoadMore && listRef && listRef.current) {
      listRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    if (isInfinite) setShowPagination(false);
  }, [isInfinite]);

  if (!showPagination) return null;
  const totalRecordsToFetch = limitToUse || listTotal;

  const numberOfPages = Math.ceil(totalRecordsToFetch / itemsPerPage);
  const isLastPage = currentPage >= numberOfPages;
  if (numberOfPages <= 1 || (isLastPage && isInfinite)) return null;

  const paginationProps = {
    name,
    numberOfPages,
    currentPage,
    isLastPage,
    onClick: scrollOnClick,
    ...props
  };

  return (
    <div className="pagination">
      {isLoadMore ? <LoadMore {...paginationProps} /> : <Classic {...paginationProps} />}
    </div>
  );
};

ListPagination.propTypes = {
  listRef: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  paginationType: PropTypes.string.isRequired,
  listTotal: PropTypes.number.isRequired,
  isInfinite: PropTypes.bool.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  limitToUse: PropTypes.number
};

ListPagination.defaultProps = {
  limitToUse: null
};

export default ListPagination;
